import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { List } from '@pella/sash-framework';
import { Image, CTA } from '../../../';
import { isValidArray } from '../../../utilities/validations';

import styles from './index.module.scss';

const Tabs = ({ data }) => {
	const [activeTab, setActiveTab] = useState(0);

	if (!isValidArray(data)) return null;

	const onTabClick = (i) => setActiveTab(i);

	return (
		<div className={styles.tabsContainer}>
			<List
				bullets='none'
				layout='fluid'
				className={styles.tabsList}
			>
				{data.map((tab, index) => (
					<li key={index}>
						<button
							className={`${styles.tab} ${activeTab === index ? styles.tab_active : ''}`}
							onClick={() => onTabClick(index)}
						>
							{tab.tab_heading}
						</button>
					</li>
				))}
			</List>

			{data.map((panel, index) => (
				<div
					key={index}
					className={`${styles.tabPanel} ${activeTab === index ? styles.tabPanel_active : ''}`}
				>
					<div className={styles.tabPanel_Grid}>
						{isValidArray(panel.image) && (
							<Image
								data={panel.image[0]}
								className={styles.tabPanel_Image}
							/>
						)}

						<div className={styles.tabPanel_Content}>
							{panel.heading && <h3 className={styles.tabPanel_Heading}>{panel.heading}</h3>}
							{panel.subheading && <div dangerouslySetInnerHTML={{ __html: panel.subheading }} />}

							{isValidArray(panel.features) && (
								<List
									bullets='none'
									className={styles.tabPanel_FNOList}
								>
									{panel.features.map((fno, index) => (
										<li key={index}>
											{fno.file?.url && (
												<Image
													data={{ image: fno.file }}
													className={styles.tabPanel_FNOImage}
													objectFit='contain'
												/>
											)}
											<div className={styles.tabPanel_FNOContent}>
												{fno.heading && <p className={styles.tabPanel_FNOHeading}>{fno.heading}</p>}
												{fno.body && <div dangerouslySetInnerHTML={{ __html: fno.body }} />}
											</div>
										</li>
									))}
								</List>
							)}
						</div>

						{panel.why_choose && (
							<div
								className={styles.tabPanel_WhyChoose}
								dangerouslySetInnerHTML={{ __html: panel.why_choose }}
							/>
						)}

						{isValidArray(panel.cta) && (
							<div className={styles.tabPanel_CtaCell}>
								<CTA data={panel.cta[0]} />
							</div>
						)}
					</div>
				</div>
			))}
		</div>
	);
};

Tabs.propTypes = {
	data: PropTypes.array,
};

export default Tabs;
